import apiClient from './api';

export enum UserActionType {
  SPEC_UPLOAD = 'SPEC_UPLOAD',
  BOM_UPLOAD = 'BOM_UPLOAD',
  BOM_ENRICHMENT = 'BOM_ENRICHMENT',
  MARKET_RESEARCH = 'MARKET_RESEARCH',
  PART_LIFECYCLE = 'PART_LIFECYCLE',
  BULK_IMPORT = 'BULK_IMPORT',
  DATASHEET_REPROCESS = 'DATASHEET_REPROCESS',
  DATASHEET_BACKFILL = 'DATASHEET_BACKFILL',
}

export enum UserActionStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export interface UserAction {
  _id: string;
  type: UserActionType;
  status: UserActionStatus;
  progress: number;
  title: string;
  subtitle?: string;
  result?: {
    navigateTo?: string;
    message?: string;
    entityId?: string;
    entityType?: string;
    [key: string]: any;
  };
  errorMessage?: string;
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface UserActionEvent {
  type: 'action:created' | 'action:updated' | 'action:completed' | 'action:failed';
  action: UserAction;
}

export const userActionService = {
  getRecentActions: async (limit = 20): Promise<UserAction[]> => {
    const response = await apiClient.get(`/user-actions?limit=${limit}`);
    return response.data;
  },

  getActiveActions: async (): Promise<UserAction[]> => {
    const response = await apiClient.get('/user-actions/active');
    return response.data;
  },

  dismissAction: async (id: string): Promise<void> => {
    await apiClient.post(`/user-actions/${id}/dismiss`);
  },

  dismissAll: async (): Promise<void> => {
    await apiClient.post('/user-actions/dismiss-all');
  },
};

/**
 * Get user context from localStorage for SSE query params
 */
export function getUserContext(): { userId: string; tenantId: string } | null {
  try {
    const userDataStr = localStorage.getItem('user_data');
    if (!userDataStr) return null;
    const userData = JSON.parse(userDataStr);
    const userId = userData?.id || userData?.userId;
    const tenantId = userData?.tenantId;
    if (!userId || !tenantId) return null;
    return { userId, tenantId };
  } catch {
    return null;
  }
}

export default userActionService;
